/**
 * Produktlogo.
 *
 * Quelle ist die Originaldatei aus `docs/brand/`. Daraus entstehen drei
 * aufbereitete Fassungen in `public/` (siehe `docs/brand/README.md`):
 *
 *   icon.png       quadratische Bildmarke, freigestellt – Kopfzeile, Favicon
 *   logo-mark.png  Bildmarke im Originalzuschnitt – für breite Flächen
 *   logo.png       Bild- und Wortmarke – Anmeldung, Startseiten
 *
 * Alle mit Alphakanal, damit sie auf hellem wie dunklem Untergrund sitzen.
 * Die Wortmarke enthält dunkelblaue und violette Buchstaben; auf dunklem
 * Grund bekommt sie deshalb eine helle Trägerfläche (siehe app.css).
 */

/** Bildmarke, quadratisch – für Kopfzeile, Seitenleiste und kleine Flächen. */
export function BrandMark({ size = 36, className }: { size?: number; className?: string }) {
  return (
    <img
      src="/icon.png"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className={`brand-mark ${className ?? ''}`}
      style={{ width: size, height: size }}
    />
  );
}

/** Bild- und Wortmarke nebeneinander – für Anmeldung und Startseiten. */
export function BrandLockup({ height = 46 }: { height?: number }) {
  return (
    <span className="brand-lockup">
      <img src="/logo.png" alt="FacilityFlow" style={{ height, width: 'auto' }} />
    </span>
  );
}
